module.exports = __webpack_public_path__ + "static/img/itemBg.e666e4a6.png";